import type { Location } from '../../../../../runtime-packages/runtimes-shared/src/RuntimeModule'

const getLocation = async (coarse?: boolean, geolocation: Geolocation = navigator.geolocation): Promise<Location> =>
  new Promise<Location>((resolve, reject) => {
    geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords
        resolve({ latitude, longitude, capturedAt: new Date(pos.timestamp).toISOString() })
      },
      (err) => {
        reject(err)
      },
      { enableHighAccuracy: coarse !== false, timeout: 5000, maximumAge: 10000 }
    )
  })

export default getLocation
